import React from "react";
import { motion } from "framer-motion";
import { BiAnalyse, BiData, BiServer } from "react-icons/bi";
import "./DataCollection.css";
import analysis from "../../Assets/analysis.webp";

const DataCollection = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  return (
    <section className="data-container">
      <motion.h3
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
      >
        ODK Mobile Data Collection
      </motion.h3>

      <motion.p
        className="intro-text"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
      >
        Simba Consultants has embraced mobile data capturing using Open Data Kit (ODK),
        a suite of open-source tools designed for efficient, secure, and reliable mobile
        data collection.
      </motion.p>

      <div className="data-content">
        {/* First Row */}
        <motion.div
          className="data-card-content"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
        >
          <motion.div
            className="data-card"
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 200 }}
          >
            <div className="icon-container">
              <BiData className="icon" />
            </div>
            <h2>Training</h2>
            <p>
              We offer training that links knowledge, skills, practice, and behavior,
              helping individuals adapt and thrive in a rapidly changing environment.
            </p>
          </motion.div>

          <motion.div
            className="data-card"
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 200 }}
          >
            <div className="icon-container">
              <BiServer className="icon" />
            </div>
            <h2>Mobile Data Capturing</h2>
            <p>
              ODK automates data capture—recording GPS locations, timestamps, and images.
              It removes errors from traditional methods, eliminates printing costs, and
              ensures instant data transfer for faster decision-making.
            </p>
          </motion.div>
        </motion.div>

        {/* Second Row */}
        <motion.div
          className="data-card-content reverse"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
        >
          <motion.div
            className="data-card"
            whileHover={{ scale: 1.03 }}
            transition={{ type: "spring", stiffness: 200 }}
          >
            <div className="icon-container">
              <BiAnalyse className="icon" />
            </div>
            <h2>Strategic Planning & Curriculum Development</h2>
            <p>
              We prepare strategic plans and curricula for health, education, and
              economic development. Our evidence-based training approaches ensure
              sustainable, measurable impact in communities.
            </p>
          </motion.div>

          <motion.div
            className="data-card-image"
            whileHover={{ scale: 1.02 }}
            transition={{ type: "spring", stiffness: 200 }}
          >
            <img src={analysis} alt="Data analysis" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default DataCollection;
